import { ApplicationStatus } from '../../../Lib/Constants/vendor-application-form-step';

export default function determineApplicationStatus(application) {
  switch (application.application_stage) {
    case ApplicationStatus.INITIATED:
      return 'Emailed - Invite sent to the vendor';
    case ApplicationStatus.VENDOR_QUESTIONNAIRE:
      return 'Vendor - Pending Application';
    case ApplicationStatus.BUYER_QUESTIONNAIRE:
      return 'Emailed - Buyer to Review Application';
    case ApplicationStatus.SPONSOR_APPROVAL:
      return 'Emailed - Sponsor to Review Application';
    case ApplicationStatus.SPONSOR_DENIED:
      return 'Sponsor Denied and Emailed Buyer, Sponsor, All Executives';
    case ApplicationStatus.FIRST_EXECUTIVE_APPROVAL:
      return 'Sponsor Approved and Emailed Executive 1';
    case ApplicationStatus.FIRST_EXECUTIVE_DENIED:
      return 'Executive 1 Denied and Emailed Buyer, Sponsor, All Executives';
    case ApplicationStatus.SECOND_EXECUTIVE_APPROVAL:
      return 'Executive 1 Approved and Emailed Executive 2';
    case ApplicationStatus.SECOND_EXECUTIVE_DENIED:
      return 'Executive 2 Denied and Emailed Buyer, Sponsor, All Executives';
    case ApplicationStatus.PRE_ONBOARDING:
      if (application.vendor_application_status === 'Application Pending') {
        return 'Executive 2 Approved and Requested Vendor for Pre-Onboarding';
      }
      if (
        application.vendor_application_status === 'Pending Accounting Approval'
      ) {
        return 'Accounting & Compliance Review Pre-Onboarding';
      }
      if (application.vendor_application_status === 'Rejected') {
        return 'Accounting & Compliance Denied Vendor';
      }
      return 'NOT APPLICABLE';
    case ApplicationStatus.APPROVED:
      return 'Vendor Approved';
    default:
      return 'NOT APPLICABLE';
  }
}
